export default __webpack_public_path__ + "static/media/icon_place.75ad756e.svg";